import { Avatar, Button, SxProps } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { UploadFilesPurpleIcon } from 'Images';
import { forwardRef } from 'react';
interface IUploadFileButton {
  clickHandler: () => void;
  children?: string;
  ariaLabel?: string;
  dataId?: string;
  variant?: 'default' | 'custom';
  customStyles?: SxProps;
  iconPosition?: 'start' | 'end';
  label?: string;
  icon?: string;
}
export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  IUploadFileButton
>((props, ref) => {
  const {
    clickHandler,
    children,
    variant = 'default',
    customStyles = {},
    iconPosition = 'end',
  } = props;
  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);
  const isDesktop = useIsDesktop();
  const dataId = props.dataId ? props.dataId : '';
  const ariaLabel = props.ariaLabel || `${dictionary.upload}`;

  const defaultStyles = isDesktop
    ? {
        width: '280px',
        fontSize: '20px',
        height: '44px',
        fontWeight: '600',
        color: '#344266',
        backgroundColor: 'purple2.shade_100',
        borderRadius: '8px',
        padding: '4px 20px',
        '&:hover': { backgroundColor: 'purple2.shade_200' },
        '& .MuiButton-endIcon': {
          ml: '-4px',
        },
      }
    : {
        width: '100%',
        fontSize: '16px',
        color: '#344266',
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '6px 16px',
        border: '1px solid #B7CCFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: '12px',
        '&:hover': { backgroundColor: 'primary.shade_200' },
        '& .MuiButton-startIcon': {
          mr: '-4px',
        },
      };

  const customVariantStyles = {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'purple2.main',
    justifyContent: 'start',
    color: 'text.primary',
    fontSize: '18px',
    '&:hover': { backgroundColor: 'purple2.shade_50' },
  };

  const styles =
    variant === 'custom'
      ? { ...defaultStyles, ...customVariantStyles, ...customStyles }
      : defaultStyles;

  const icon = (
    <Avatar
      alt=''
      src={UploadFilesPurpleIcon}
      sx={{ width: '32px', height: '32px', p: '4px' }}
    />
  );

  return (
    <Button
      data-id={dataId}
      ref={ref}
      sx={styles}
      onClick={clickHandler}
      aria-label={ariaLabel}
      tabIndex={dataId ? undefined : -1}
      startIcon={iconPosition === 'start' ? icon : undefined}
      endIcon={iconPosition === 'end' ? icon : undefined}
    >
      {children}
    </Button>
  );
});
